export const environment = {
  production: true,
  buildId: '3871405217523691',
  configFile: 'config.json',
};
